import AppComponent from './app.settings';

const AUTHORIZATION_REPEAT_DELAY = 5000; // 5 seconds

/**
 * App specific routes and state configuration
 * @param {$stateProvider} $stateProvider ui-router state provider
 * @param {$urlRouterProvider} $urlRouterProvider ui-router provider
 * @param {$locationProvider} $locationProvider location provider
 * @constructor
 * @ngInject
 */
export default function AppRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    const mainState = {
        abstract: true,
        component: AppComponent.selector,
        resolve: {
            /** @ngInject */
            storedUser: AuthService => AuthService.getUser(),
            /** @ngInject */
            authorizedUser: (storedUser, AuthService) => {
                if (storedUser && !storedUser.expired) {
                    return storedUser;
                }

                return AuthService.silentLogin().catch(() => null);
            },
            /**
             * This resolve is used only to initialize remote configuration loader and load config
             * @ngInject
             */
            remoteConfig: RemoteConfigService => RemoteConfigService.loadConfig(),
            /** @ngInject */
            folders: (authorizedUser, FolderService) => {
                if (authorizedUser) {
                    return FolderService.loadFolders().catch(() => null);
                }
                return null;
            }
        },
        /** @ngInject */
        onEnter: (authorizedUser, $state) => { // eslint-disable-line consistent-return
            if (!authorizedUser) {
                return $state.target('auth');
            }
        }
    };

    $stateProvider
        .state('auth', {
            url: '/auth',
            /** @ngInject */
            onEnter: (AuthService) => {
                AuthService.login();
            }
        });

    $stateProvider
        .state('auth-process', {
            url: '/auth/process',
            resolve: {
                /** @ngInject */
                authorizedUser: AuthService => AuthService.authorize().catch(() => null)
            },
            /** @ngInject */
            onEnter: (authorizedUser, $state) => { // eslint-disable-line consistent-return
                if (authorizedUser) {
                    return $state.target('main.sensors.list');
                }

                setTimeout(() => {
                    location.href = '/sensors-and-connectors';
                }, AUTHORIZATION_REPEAT_DELAY);
            }
        });

    $stateProvider
        .state('main', mainState);

    $urlRouterProvider.otherwise('/sensors-and-connectors');
}



// WEBPACK FOOTER //
// ./app/app.router.js